import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-link",
  "use": "icon-link-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-link\"><path d=\"M115.6 128H.1V12.3h57.7v12.3H12.4v90.9h90.9V70.2h12.3z\" /><path d=\"M116.4 2.8l8.8 8.8-56.8 56.7-8.7-8.7z\" /><path d=\"M127.9 38h-12.4V12.4H88.7V0H128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol